import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { IonicModule } from '@ionic/angular';
import { FooterModule } from '../footer/footer.module';
import { EmManutencaoComponent } from './em-manutencao.component';

@NgModule({
  declarations: [EmManutencaoComponent],
  imports: [
    CommonModule,
    IonicModule,

    // components
    FooterModule,
  ],
  exports: [EmManutencaoComponent]
})
export class EmManutencaoModule { } 